import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Hero } from "@/components/home/Hero";
import { PersonaTabs } from "@/components/home/PersonaTabs";
import { SolutionsBento } from "@/components/home/SolutionsBento";
import { CoverageMap } from "@/components/home/CoverageMap";
import { TrustStrip } from "@/components/home/TrustStrip";
import { WhyUs } from "@/components/home/WhyUs";
import { Stats } from "@/components/home/Stats";
import { Testimonials } from "@/components/home/Testimonials";
import { IndustriesGrid } from "@/components/home/IndustriesGrid";
import { AboutTeaser } from "@/components/home/AboutTeaser";
import { PostCard } from "@/components/home/PostCard";
import { Marquee } from "@/components/site/Marquee";
import { CTABand } from "@/components/site/CTABand";
import { MaskLines } from "@/components/site/Reveal";
import { POSTS } from "@/data/content";
import { useSeo } from "@/hooks/useSeo";

const ResourcesTeaser = () => (
  <section data-testid="resources-teaser" className="border-t border-slate-200 bg-white py-24 sm:py-32">
    <div className="container-x">
      <div className="flex flex-col gap-6 md:flex-row md:items-end md:justify-between">
        <div>
          <p className="eyebrow text-[#1777AF]">Resources</p>
          <MaskLines lines={["Field notes from", "the operations desk."]} className="mt-5 font-display text-4xl font-bold leading-[1.02] tracking-tight text-slate-900 sm:text-5xl" />
        </div>
        <Link to="/resources" data-testid="resources-view-all" className="btn-ghost w-fit border-slate-300 text-slate-900 hover:border-[#1777AF] hover:text-[#1777AF]">
          All articles <ArrowUpRight className="h-4 w-4" />
        </Link>
      </div>
      <div className="mt-14 grid gap-10 md:grid-cols-3">
        {POSTS.slice(0, 3).map((p, i) => <PostCard key={p.slug} post={p} i={i} />)}
      </div>
    </div>
  </section>
);

export default function Home() {
  useSeo("Bodhatek | Affordable Managed IT, Dispatch & Nationwide Onsite Support", "Managed IT, dispatch and onsite support nationwide across the USA — from one partner, at a very reasonable cost.");
  return (
    <div data-testid="home-page">
      <Hero />
      <Marquee />
      <PersonaTabs />
      <SolutionsBento />
      <CoverageMap />
      <TrustStrip />
      <WhyUs />
      <Stats />
      <Testimonials />
      <IndustriesGrid />
      <AboutTeaser />
      <ResourcesTeaser />
      <CTABand />
    </div>
  );
}
